export default {
      id: "menu__units-groups-usage",
      viewBox: "0 0 21 16",
      url: __webpack_public_path__ + "img/icons.svg#menu__units-groups",
      toString: function () {
        return this.url;
      }
    }